import { RouteObject } from "react-router-dom";
import { AuthCallback, ClientOnboarding, LogoutCallback, OperatorOnboarding, UserAccountOnboarding } from "@/components/pages";
import { ConfigProvider } from "@/components/organisms";
import { RequireAuth } from "./RequireAuth/RequireAuth";
import { RequireClientOnboarding } from "./RequireClientOnboarding";
import { RequireOperatorOnboarding } from "./RequireOperatorOnboarding";

export const kindeRoutes: RouteObject[] = [
  {
    path: "/auth-callback",
    element: <AuthCallback />,
  },
  {
    path: "/logout-callback",
    element: <LogoutCallback />,
  },
  // Note: invite/:inviteKey route is defined in routes/index.tsx as the first child route
  // to ensure it takes priority over authRoutes invite/:token
  //
  // All onboarding routes are wrapped in ConfigProvider because they sit outside
  // the Public/Private containers, and child components (GeneralLogo, GeneralFooter)
  // require site config from Redux.

  // Operator onboarding: KYC + Platform Setup
  {
    path: "/onboarding/operator",
    element: <RequireAuth />,
    children: [
      {
        path: "",
        element: <RequireOperatorOnboarding />,
        children: [
          {
            index: true,
            element: (
              <ConfigProvider>
                <OperatorOnboarding />
              </ConfigProvider>
            ),
          },
        ],
      },
    ],
  },
  // Client onboarding: KYC only
  {
    path: "/onboarding/client",
    element: <RequireAuth />,
    children: [
      {
        path: "",
        element: <RequireClientOnboarding />,
        children: [
          {
            index: true,
            element: (
              <ConfigProvider>
                <ClientOnboarding />
              </ConfigProvider>
            ),
          },
        ],
      },
    ],
  },
  // User account onboarding: Complete registration after Kinde auth
  {
    path: "/onboarding/invite/:inviteKey",
    element: <RequireAuth />,
    children: [
      {
        index: true,
        element: (
          <ConfigProvider>
            <UserAccountOnboarding />
          </ConfigProvider>
        ),
      },
    ],
  },
];
